module.exports = __webpack_public_path__ + "static/media/underconstruction.899de82a.png";